import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import TableDescriptors from '../../../definitions/tableDescriptors';
import EntityTable from '../../components/common/entity/entityTable';
import LocaleTooling from '../../../tooling/localeTooling';

/* Actions */
import * as reportFileAdminActions from '../../actions/reportFileAdmin/index';

/*Components*/
import GlassPopup from '../../components/common/interface/glassPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import GenerateReportFilesHeader from '../../components/reportFileAdmin/generateReportFilesHeader';
import CalculationUnitsFilter from '../../components/reportFileAdmin/calculationUnitsFilter';
import GenerateButton from '../../components/reportFileAdmin/generateButton';
import EmailDetailPopup from '../../components/reportFileAdmin/emailDetailPopup';
import EmailFinderByCalculationUnitPopup from '../../components/reportFileAdmin/emailFinderByCalculationUnitPopup';

const popupIds = {
  reportFileDeletePopup: "reportFileDeletePopup",
  generateReportFilesConfirmPopup: "generateReportFilesConfirmPopup",
  regenerateReportFilesConfirmPopup: "regenerateReportFilesConfirmPopup",    
  emailDetailPopup: "emailDetailPopup",
  sendReportFileToEmailsConfirmPopup: "sendReportFileToEmailsConfirmPopup",
  emailFinderByCalculationsUnitsPopup: "emailFinderByCalculationsUnitsPopup"
}

class ReportFilesPopupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      generateReportFilesFilters: {
        filterGroup: "",
        criteria: Constants.calculationFilters.calculationUnitFilter.ALL,
        calculationUnitsSelected: [],
        ignoreZeroTotalValue: false
      },
      getCalculationUnitForEmailFilters: {
        filterGroup: "",
        criteria: Constants.calculationFilters.calculationUnitFilter.ALL,
        calculationUnitsSelected: [],
      },
      getCalculationUnitForEmailSearchFilters:{
        calculationUnitsSelected: [],
      },
      regenerateReportFilesFilters: null,
      deleteReportFileTextInfo: "",
      sendReportFileToEmailsTextInfo: "",
      tableEmailDetailDescriptor: TableDescriptors.emailDetailList,
      report_file_id: null,
    };
  }
 
  componentDidMount() {
    if(this.props.periodId) {
      this.props.actions.getGroupsList(this.props.periodId);
    }
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.periodId!=this.props.periodId && this.props.periodId) {
      this.props.actions.getGroupsList(this.props.periodId);
    }
    if(InterfaceTooling.popupHasToRender(this.props.popupState)) {
      //handle generate report files feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.generateReportFiles.status],
        [this.props.generateReportFiles.status],
        intl.formatMessage({ id: "reportFileAdmin.generateReportFilesSuccess" }),
        this.props.generateReportFiles.status==423 ?
          intl.formatMessage({ id: "common.errors.systemLockedError" }) :
          intl.formatMessage({ id: "reportFileAdmin.generateReportFilesFailure" }),
        [async () => {
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.generateReportFilesConfirmPopup])) {
            InterfaceTooling.popupHide(popupIds.generateReportFilesConfirmPopup, this.setState.bind(this));
          }
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.regenerateReportFilesConfirmPopup])) {
            InterfaceTooling.popupHide(popupIds.regenerateReportFilesConfirmPopup, this.setState.bind(this));
          }
        }]
      );

      //handle delete report file feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.deleteReportFile.status],
        [this.props.deleteReportFile.status],
        intl.formatMessage(
          { id: "common.entity.deleteEntitySuccess" },
          {entityNameSingular: FormatTooling.toUpperCaseFirst(TableDescriptors.reportFilesList.entityNameSingularWithArticle), 
           genderVocal: TableDescriptors.reportFilesList.genderVocal }),
        this.props.deleteReportFile.status==423 ?
          intl.formatMessage({ id: "common.errors.systemLockedError" }) :
          (this.props.deleteReportFile.status==424 ?
            LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "reportFileAdmin.errors.cannotDeleteReportFileByEmailsSend" })) :
            intl.formatMessage(
              { id: "common.entity.deleteEntityError" },
              {entityNameSingular: TableDescriptors.reportFilesList.entityNameSingularWithArticle.toLowerCase()})
        ),
        [() => {
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.reportFileDeletePopup])) {
            InterfaceTooling.popupHide(popupIds.reportFileDeletePopup, this.setState.bind(this));
          }
          this.props.actions.getReportFilesHistory({
            period_id: this.props.periodId,
            per_page: Constants.interface.popupPageSize,
            page: 1
          }); 
        }]    
      );
      
      //handle download report feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.downloadReportFile.status],
        [this.props.downloadReportFile.status],
        intl.formatMessage({ id: "reportFileAdmin.downloadFileSuccess" }),
        intl.formatMessage({ id: "reportFileAdmin.downloadFileFailure" })
      );

      //handle send emails feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.sendReportFileToEmails.status],
        [this.props.sendReportFileToEmails.status],
        intl.formatMessage({ id: "reportFileAdmin.email.sendEmailsSuccess" }),
        intl.formatMessage({ id: "reportFileAdmin.email.sendEmailsError" }),
        [() => {
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.sendReportFileToEmailsConfirmPopup])) {
            InterfaceTooling.popupHide(popupIds.sendReportFileToEmailsConfirmPopup, this.setState.bind(this));
          }
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.emailDetailPopup])) {
            InterfaceTooling.popupHide(popupIds.emailDetailPopup, this.setState.bind(this));
          }
        }] 
      );
    }
  }
  
  handleOnChangeGenerateReportFilesFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.generateReportFilesFilters[path];
    let generateReportFilesFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.generateReportFilesFilters);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = generateReportFilesFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
      } else {
        var selectedItem = this.props.calculationUnitsFilter.data.find(item => item.id==listValue);
        var exists = this.state.generateReportFilesFilters.calculationUnitsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "periodAdmin.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    generateReportFilesFiltersNew[path] = value;
    
    if((path=="criteria" && value==Constants.calculationFilters.calculationUnitFilter.ALL) ||
      (path=="filterGroup" && value!="" && value!=this.state.generateReportFilesFilters.filterGroup)) {
      generateReportFilesFiltersNew.calculationUnitsSelected = [];
    }
    
    this.setState({
      generateReportFilesFilters: generateReportFilesFiltersNew
    });    
  };

  handleFetchFilterCalculationUnits = async (keyword) => {
    await this.props.actions.getCalculationUnitsList(keyword, this.state.generateReportFilesFilters.filterGroup, this.props.periodId);
  };

  handleOnChangeCalculationUnitsEmailFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.getCalculationUnitForEmailFilters[path];
    let getCalculationUnitForEmailFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.getCalculationUnitForEmailFilters);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = getCalculationUnitForEmailFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
      } else {
        var selectedItem = this.props.calculationUnitsFilterEmail.data.find(item => item.id==listValue);
        var exists = this.state.getCalculationUnitForEmailFilters.calculationUnitsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "periodAdmin.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    getCalculationUnitForEmailFiltersNew[path] = value;
    
    if((path=="criteria" && value==Constants.calculationFilters.calculationUnitFilter.ALL) ||
      (path=="filterGroup" && value!="" && value!=this.state.getCalculationUnitForEmailFilters.filterGroup)) {
        getCalculationUnitForEmailFiltersNew.calculationUnitsSelected = [];
    }
    
    this.setState({
      getCalculationUnitForEmailFilters: getCalculationUnitForEmailFiltersNew
    });    
  };

  handleFetchFilterCalculationUnitsEmail = async (keyword) => {
    await this.props.actions.getCalculationUnitsEmailList(keyword, this.state.getCalculationUnitForEmailFilters.filterGroup, this.props.periodId);
  };

  handleRefreshReportFiles = event => {
    this.props.actions.getReportFilesHistory({
      period_id: this.props.periodId,
      per_page: Constants.interface.popupPageSize,
      page: 1
    });
  };

  handleReportFilesPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.reportFilesHistory.status === 200 && this.props.reportFilesHistory.page<=this.props.reportFilesHistory.totalPages) {
      this.props.actions.getReportFilesHistory({
        period_id: this.props.periodId,
        per_page: Constants.interface.popupPageSize,
        page: page
      });
    }  
  };

  handleReportFileDeletePopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.reportFileDeletePopup, this.state, 
      this.setState.bind(this), this.props.deleteReportFile.loading, () => {
        var reportFile = JSON.parse(event.currentTarget.dataset.entitydata);
        this.props.actions.prepareDeleteReportFile(event.currentTarget.dataset.id);
        this.setState({
          deleteReportFileTextInfo: FormatTooling.toUpperCaseFirst(intl.formatMessage( {id: "reportFileAdmin.entityNameSingular"})) + 
            ": " + FormatTooling.defaultsTextFormatTypes(reportFile.created_at,Constants.crudGenerator.dataTypes.DATETIME) + 
            " - " + reportFile.detail
        });
      }
    );
  };
    
  handleReportFileDeleteConfirm = async () => {
    await this.props.actions.deleteReportFile({id: this.props.deleteReportFile.id});
  };

  handleGenerateReportFilesConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.generateReportFilesConfirmPopup, this.state, 
      this.setState.bind(this), this.props.generateReportFiles.loading
    );
  };
  
  handleGenerateReportFiles = (event) => {
    this.props.actions.generateReportFiles({ 
      generate_report_files_params: {
        period_id: this.props.periodId,
        group_id: this.state.generateReportFilesFilters.filterGroup,
        calculation_units_criteria: this.state.generateReportFilesFilters.criteria,
        calculation_units: this.state.generateReportFilesFilters.calculationUnitsSelected,
        ignore_zero_total_value: this.state.generateReportFilesFilters.ignoreZeroTotalValue
      } 
    });
  };

  handleRegenerateReportFilesConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.regenerateReportFilesConfirmPopup, this.state, 
      this.setState.bind(this), this.props.generateReportFiles.loading, () => {
        var reportFile = JSON.parse(event.currentTarget.dataset.entitydata);
        if(reportFile.filters_object) {
          reportFile.filters_object.regenerate = true;
          reportFile.filters_object.notificacion_regenerate_id = reportFile.job_key;
        }
        this.setState({
          regenerateReportFilesFilters: reportFile.filters_object
        });
      }
    );
  };  

  handleRegenerateReportFiles = (event) => {
    this.props.actions.generateReportFiles({ 
      generate_report_files_params: this.state.regenerateReportFilesFilters
    });
  };

  handleDownloadReportFile = async (event) => {  
    var report = JSON.parse(event.currentTarget.dataset.entitydata);
    if(!report.has_file) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.warning(intl.formatMessage( {id: "reportFileAdmin.downloadFileFailureNoFileGenerated"}),""); 
    }
    else {
      await this.props.actions.downloadReportFile({
        reportFileId: report.id
      }, report);
    }      
  };

  handleEmailHistoryNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.emailHistory.status === 200 && this.props.emailHistory.page<=this.props.emailHistory.totalPages) {
      this.props.actions.getEmailHistory({
        period_id: this.props.periodId,
        per_page: Constants.interface.emailHistoryPageSize,
        page: page
      });
    }  
  };
  
  handleSendReportFiletoEmailsConfirmPopup = async (event) => {
    this.setState({
      report_file_id: null,
      sendReportFileToEmailsTextInfo: ""
    })
    InterfaceTooling.handleShowPopup(
      event, popupIds.sendReportFileToEmailsConfirmPopup, this.state, 
      this.setState.bind(this), this.props.generateReportFiles.loading, () => {
        if(event.currentTarget.dataset.entitydata){
          var reportFile = JSON.parse(event.currentTarget.dataset.entitydata);
          this.setState({
            report_file_id: reportFile.id,
            sendReportFileToEmailsTextInfo: FormatTooling.toUpperCaseFirst(intl.formatMessage( {id: "reportFileAdmin.entityNameSingular"})) + 
              ": " + FormatTooling.defaultsTextFormatTypes(reportFile.created_at,Constants.crudGenerator.dataTypes.DATETIME) + 
              " - " + reportFile.detail + " - " + 
              reportFile.calculation_units_info + " " +
              FormatTooling.toUpperCaseFirst(+reportFile.calculation_units_info == 1 ? LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNameSingular"})) : LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"})))
          });
        }
      }
    );
  };  

  handleSendReportFiletoEmails = async (event) => {
    if(this.state.report_file_id){
      this.props.actions.sendReportFileToEmails({
        send_report_files_mails_params: {
          period_id: this.props.periodId,
          report_file_id: this.state.report_file_id
        } 
      });      
    }
    else{
      this.props.actions.sendReportFileToEmails({ 
        send_report_files_mails_params: {
          period_id: this.props.periodId,
          group_id: this.state.getCalculationUnitForEmailFilters.filterGroup,
          calculation_units_criteria: this.state.getCalculationUnitForEmailFilters.criteria,
          calculation_units: this.state.getCalculationUnitForEmailFilters.calculationUnitsSelected,
        } 
      });
    }
  }; 


  handleShowEmailDetailPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.emailDetailPopup, this.state, 
      this.setState.bind(this), this.props.emailHistory.loading, () => {
        this.props.actions.getEmailHistory({
          period_id: this.props.periodId,
          per_page: Constants.interface.emailHistoryPageSize,
          page: 1
        });
      }      
    );
  }

  handleRefreshEmailHistory = (event) => {
    this.props.actions.getEmailHistory({
      period_id: this.props.periodId,
      per_page: Constants.interface.emailHistoryPageSize,
      page: 1
    });
  }

  handleShowEmailFinderByCalculationsUnitsPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.emailFinderByCalculationsUnitsPopup, this.state, 
      this.setState.bind(this),this.props.calculationUnitsFilterEmailSearch.loading, () => {        
      }      
    );
  }

  handleOnChangeCalculationUnitsEmailSearchFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.getCalculationUnitForEmailSearchFilters[path];
    let getCalculationUnitForEmailSearchFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.getCalculationUnitForEmailSearchFilters);
    let refreshQuery = false;
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = getCalculationUnitForEmailSearchFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
        refreshQuery = true;
      } else {
        var selectedItem = this.props.calculationUnitsFilterEmailSearch.data.find(item => item.id==listValue);
        var exists = this.state.getCalculationUnitForEmailSearchFilters.calculationUnitsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
          refreshQuery = true;
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "periodAdmin.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;    
      getCalculationUnitForEmailSearchFiltersNew[path] = value;
      this.setState({ getCalculationUnitForEmailSearchFilters: getCalculationUnitForEmailSearchFiltersNew });  
      
      if(refreshQuery) {
        this.props.actions.getCalculationUnitsEmailSearchQueryList({
          period_id: this.props.periodId,
          calculation_units: getCalculationUnitForEmailSearchFiltersNew.calculationUnitsSelected.map(item => item.id),
        });
      }
    }  
  };

  handleFetchFilterCalculationUnitsEmailSearch = async (keyword) => {
    await this.props.actions.getCalculationUnitsEmailSearchList(keyword, this.props.periodId);
  };

  render() {
    let tableHandleDelete = this.handleReportFileDeletePopup;
    let tableActions = [this.handleDownloadReportFile,this.props.handleNotificationDetailPopupReference, this.handleRegenerateReportFilesConfirmPopup, this.handleSendReportFiletoEmailsConfirmPopup];
    let tableActionsIcons = ["download","info-circle","retweet","paper-plane"];
    let tableActionsTooltips = [
      intl.formatMessage({ id: "reportFileAdmin.downloadLink"}),
      intl.formatMessage({ id: "reportFileAdmin.tableActions.info"}),
      LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "reportFileAdmin.tableActions.regenerateReportFiles"})),
      intl.formatMessage({ id: "reportFileAdmin.tableActions.sendReportFileToEmails"}),
    ];
    let tableActionsForceShow = [false,true,false,false];

    let popupHandleExtraButton = this.handleShowEmailDetailPopup;
    let popupExtraButtonIcon="envelope";

    if(this.props.onlyView) {
      tableHandleDelete = null;
      popupHandleExtraButton=null;
      popupExtraButtonIcon=null;
      tableActions = [this.handleDownloadReportFile,this.props.handleNotificationDetailPopupReference];
      tableActionsIcons = ["download","info-circle"];
      tableActionsTooltips = [
        intl.formatMessage({ id: "reportFileAdmin.downloadLink"}),
        intl.formatMessage({ id: "reportFileAdmin.tableActions.info"})
      ];
      tableActionsForceShow = [false,true];
    }
    return (
      <div>
        <GlassPopup
          className="form_popup report_files_popup notifications_popup"
          handleExtraButton={popupHandleExtraButton}
          extraButtonIcon={popupExtraButtonIcon}
          handleShowPopup={this.props.handleRepotFilesPopup}
          handleRefresh={this.handleRefreshReportFiles}
          fullLoading={this.props.reportFilesHistory.loading || 
            this.props.reportFilesHistory.firstLoading ||
            this.props.downloadReportFile.loading}
          popupState={this.props.popupState}
          title={(<FormattedMessage id={"reportFileAdmin.title"}/>)}
        >
          <section className={"left_filter_fixed_section_parent left_filter_fixed_section_parent_popup" + (this.props.onlyView ? " left_filter_fixed_section_parent_hidden" : "")}>
            {(!this.props.onlyView) ? (
              <div className="left_filter_fixed_section">
                <GenerateReportFilesHeader/>
                <CalculationUnitsFilter
                  onChangeFilter={this.handleOnChangeGenerateReportFilesFilters}
                  filterValues={this.state.generateReportFilesFilters}
                  groupsData={this.props.groupsFilter.data}
                  groupsLoading={this.props.groupsFilter.loading}
                  calculationUnitsData={this.props.calculationUnitsFilter.data}
                  calculationUnitsLoading={this.props.calculationUnitsFilter.loading}
                  calculationUnitsFetchAction={this.handleFetchFilterCalculationUnits}
                />
                <GenerateButton
                  loadingGenerate={this.props.generateReportFiles.loading}
                  handleGenerate={this.handleGenerateReportFilesConfirmPopup}
                  generateDisabled={this.state.generateReportFilesFilters.criteria=="" || 
                    (this.state.generateReportFilesFilters.criteria==Constants.calculationFilters.calculationUnitFilter.ONLY &&
                    this.state.generateReportFilesFilters.calculationUnitsSelected.length==0)
                  }
                />
              </div>
            ) : null }
            <div className="right_filter_content_section_on_popup">
              <EntityTable
                entityTableDescriptor={this.props.hasReprocess ? TableDescriptors.reportFilesReprocessList : TableDescriptors.reportFilesList}
                data={this.props.reportFilesHistory.data}
                loading={this.props.reportFilesHistory.loading}
                page={this.props.reportFilesHistory.page}
                totalPages={this.props.reportFilesHistory.totalPages}
                totalRecords={this.props.reportFilesHistory.totalRecords}
                orderBy={this.props.reportFilesHistory.orderBy}
                orderByDirection={this.props.reportFilesHistory.orderByDirection}
                fetchListChangePage={this.handleReportFilesPopupNextPage}          
                handleDelete={tableHandleDelete}                  
                handleCustomActions={tableActions}
                customActionsIcons={tableActionsIcons}
                customActionsTooltips={tableActionsTooltips}
                customActionsForceShow={tableActionsForceShow}
                showBaseActionsField={this.props.hasReprocess ? "is_reprocess" : null}
              />
            </div>
          </section>
        </GlassPopup>        
        {!this.props.onlyView && (
          <EmailDetailPopup
            handleShowPopup={this.handleShowEmailDetailPopup}
            emailHistoryPage={this.props.emailHistory.page}
            emailHistoryTotalPages={this.props.emailHistory.totalPages}
            emailHistoryTotalRecords={this.props.emailHistory.totalRecords}
            emailHistoryFetchListChangePage={this.handleEmailHistoryNextPage}
            emailHistoryData={this.props.emailHistory.data}
            emailHistoryLoading={this.props.emailHistory.loading}
            fullLoading={this.props.emailHistory.firstLoading}
            emailHistoryHandleNotificationDetail={this.props.handleNotificationDetailPopupReference}
            calcFilterOnChangeFilter={this.handleOnChangeCalculationUnitsEmailFilters}
            calcFilterFilterValues={this.state.getCalculationUnitForEmailFilters}
            calcFilterGroupsData={this.props.groupsFilter.data} 
            calcFilterGroupsLoading={this.props.groupsFilter.loading}
            calcFilterCalculationUnitsData={this.props.calculationUnitsFilterEmail.data}
            calcFilterCalculationUnitsLoading={this.props.calculationUnitsFilterEmail.loading}
            calcFilterCalculationUnitsFetchAction={this.handleFetchFilterCalculationUnitsEmail}
            handleButton={this.handleSendReportFiletoEmailsConfirmPopup}
            handleSearchButton={this.handleShowEmailFinderByCalculationsUnitsPopup}
            popupState={this.state[popupIds.emailDetailPopup]}
            periodData={this.props.periodData}
            handleRefreshEmailHistory={this.handleRefreshEmailHistory}
          />
        )}
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage 
           id={"common.entity.deleteEntityConfirmTitle"}
           values={{entityNameSingular: (<FormattedMessage id={"reportFileAdmin.entityNameSingular"}/>)}}
          />)}
          confirmText={(<div>
            <FormattedMessage 
             id={"common.entity.deleteEntityConfirm"}
             values={{entityNameSingular: (<FormattedMessage id={"reportFileAdmin.entityNameSingularWithArticle"}/>)}}
            />
            <div>{this.state.deleteReportFileTextInfo}</div>
          </div>)}
          handleConfirm={this.handleReportFileDeleteConfirm}
          handleCancel={this.handleReportFileDeletePopup}
          popupState={this.state[popupIds.reportFileDeletePopup]}
          loading={this.props.deleteReportFile.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"reportFileAdmin.generateReportFilesPopupTitle"}/>)}
          confirmText={(<FormattedMessage id={"reportFileAdmin.generateReportFilesPopupDetail"}/>)}
          handleConfirm={this.handleGenerateReportFiles}
          handleCancel={this.handleGenerateReportFilesConfirmPopup}
          popupState={this.state[popupIds.generateReportFilesConfirmPopup]}
          loading={this.props.generateReportFiles.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"reportFileAdmin.regenerateReportFilesPopupTitle"}/>)}
          confirmText={(LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"reportFileAdmin.regenerateReportFilesPopupDetail"}/>))}
          handleConfirm={this.handleRegenerateReportFiles}
          handleCancel={this.handleRegenerateReportFilesConfirmPopup}
          popupState={this.state[popupIds.regenerateReportFilesConfirmPopup]}
          loading={this.props.generateReportFiles.loading}
        />
        <GlassConfirmPopup
          confirmTitle={(<FormattedMessage id={"reportFileAdmin.sendReportFileToEmailsConfirmPopupTitle"}/>)}
          confirmText={(
            <div>
              <FormattedMessage id={"reportFileAdmin.sendReportFileToEmailsConfirmPopupDetail"}/>
              <div>{this.state.sendReportFileToEmailsTextInfo}</div>
            </div>
          )}
          handleConfirm={this.handleSendReportFiletoEmails}
          handleCancel={this.handleSendReportFiletoEmailsConfirmPopup}
          popupState={this.state[popupIds.sendReportFileToEmailsConfirmPopup]}
          loading={this.props.sendReportFileToEmails.loading}
        />
        <EmailFinderByCalculationUnitPopup
          popupState={this.state[popupIds.emailFinderByCalculationsUnitsPopup]}
          queryData={this.props.calculationUnitsFilterEmailSearchQuery.data}
          queryStatus={this.props.calculationUnitsFilterEmailSearchQuery.status}
          handleShowPopup={this.handleShowEmailFinderByCalculationsUnitsPopup}
          filterValues={this.state.getCalculationUnitForEmailSearchFilters}
          onChangeFilter={this.handleOnChangeCalculationUnitsEmailSearchFilters}
          calculationUnitsData={this.props.calculationUnitsFilterEmailSearch.data}
          calculationUnitsFetchAction={this.handleFetchFilterCalculationUnitsEmailSearch}
          calculationUnitsLoading={this.props.calculationUnitsFilterEmailSearch.loading}
          fullLoading={this.props.calculationUnitsFilterEmailSearchQuery.loading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  groupsFilter: state.reducer.reportFileAdmin.groupsFilter,
  emailHistory: state.reducer.reportFileAdmin.emailHistory,
  sendReportFileToEmails: state.reducer.reportFileAdmin.sendReportFileToEmails,
  calculationUnitsFilter: state.reducer.reportFileAdmin.calculationUnitsFilter,
  calculationUnitsFilterEmail: state.reducer.reportFileAdmin.calculationUnitsFilterEmail,
  calculationUnitsFilterEmailSearch: state.reducer.reportFileAdmin.calculationUnitsFilterEmailSearch,
  calculationUnitsFilterEmailSearchQuery: state.reducer.reportFileAdmin.calculationUnitsFilterEmailSearchQuery,
  generateReportFiles: state.reducer.reportFileAdmin.generateReportFiles,
  reportFilesHistory: state.reducer.reportFileAdmin.reportFilesHistory,
  deleteReportFile: state.reducer.reportFileAdmin.deleteReportFile,  
  downloadReportFile: state.reducer.reportFileAdmin.downloadReportFile,
  handleNotificationDetailPopupReference: state.reducer.dashboard.handleNotificationDetailPopupReference
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(reportFileAdminActions, dispatch)
});

ReportFilesPopupContainer.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportFilesPopupContainer);



// WEBPACK FOOTER //
// ./source/client/containers/reportFileAdmin/reportFilesPopupContainer.jsx